<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="工资信息" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="360px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="70px">
        <el-form-item label="姓名：" prop="username">
          <el-input size="mini" v-model.trim="form.username" disabled clearable></el-input>
        </el-form-item>
        <el-form-item label="工资：" prop="wages">
          <el-input size="mini" type="number" v-model.trim="form.wages" placeholder="请输入工资" clearable></el-input>
        </el-form-item>
        <el-form-item label="提成(%)：" prop="roy">
          <el-input size="mini" type="number" v-model.trim="form.roy" placeholder="请输入提成" clearable></el-input>
        </el-form-item>
        <el-form-item label="考核工资：" prop="checkMoney">
          <el-input size="mini" type="number" v-model.trim="form.checkMoney" placeholder="请输入考核工资" clearable></el-input>
        </el-form-item>

        <el-form-item label="台量：" prop="num">
          <el-input size="mini" type="number" v-model.trim="form.num" placeholder="请输入台量" clearable></el-input>
        </el-form-item>

        <el-form-item label="单价：" prop="price">
          <el-input size="mini" type="number" v-model.trim="form.price" placeholder="请输入单价" clearable></el-input>
        </el-form-item>

        <el-form-item label="绩效工资：" prop="commissionMoney">
          <el-input size="mini" type="number" v-model.trim="form.commissionMoney" placeholder="请输入绩效工资"
            clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {
    saveWagesUser,
    getUserWages
  } from "@/api/AdminUserManagement";
  export default {
    data() {
      return {
        form: {
          userId: '',
          wages: '',
          roy: '',
          checkMoney: '',
          num: '',
          price: '',
          commissionMoney: ''
        },
        rules: {
          wages: [{
            required: true,
            message: '请输入工资',
            trigger: 'blur'
          }]
        },
      }
    },
    props: ["detail"],
    created() {
      this.getUserDetail();
      this.form.username = this.detail.nickname;
    },
    methods: {
      async getUserDetail() {
        const res = await getUserWages({
          userId: this.detail.id
        });
        if (res.code === 200) {
          if (res.data) {
            this.form = res.data;
          }
        }
      },
      handleBeforeClose(done) {
        this.$emit('cancel')
        done()
      },
      handleCancel() {
        this.$emit('cancel')
      },
      async handleConfirm() {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            const params = {
              ...this.form
            }
            params.userId = this.detail.id;
            const res = await saveWagesUser(params)
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.$emit('cancel')
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/UserManagement/components/UserWages.vue